import { memo, useMemo } from "react";

import { type FooterSectionSettings } from "@react/sections/Footer/Footer.data";
import {
  AVAILABLE_MARKETS,
  type MarketIsoCode,
} from "@root/tablescape/constants";
import { ObjectKeys } from "@root/tablescape/utilities";
import { DrawerProvider } from "@sections/DrawerProvider";
import { CountrySelectorView } from "@sections/DrawerProvider/CountrySelector/CountrySelector.view";
import { GlobalDrawer } from "@tablescape/state";

export type Localization = (typeof AVAILABLE_MARKETS)[MarketIsoCode];

const CountrySelectorBase = ({
  isoCode = "US",
  text,
}: {
  isoCode: MarketIsoCode;
  text: FooterSectionSettings["countrySelector"]["text"];
}) => {
  const localization = useMemo(() => {
    return AVAILABLE_MARKETS[isoCode];
  }, [isoCode]);

  const localizationOptions = useMemo(() => {
    return ObjectKeys(AVAILABLE_MARKETS).map(
      (key) => AVAILABLE_MARKETS[key as MarketIsoCode]
    );
  }, []);

  return (
    <DrawerProvider
      render={({ accessibilityProps, closeDrawer }) => (
        <CountrySelectorView
          accessibilityProps={accessibilityProps}
          closeSelector={closeDrawer}
          localization={localization}
          localizationOptions={localizationOptions}
          text={text}
        />
      )}
      target={GlobalDrawer.COUNTRY_SELECTOR}
    />
  );
};

export const CountrySelector = memo(CountrySelectorBase);
